import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import { Moment } from 'moment';
import React from 'react';
import { FilterProps } from '../types';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    marginRight: theme.spacing(2),
    width: 34
  },
  bottomItem: {
    marginTop: theme.spacing(2)
  }
}))

const DateFilter = (props: FilterProps<'date'>) => {
  const {state = {}, setState, validate, setValid} = props;
  const classes = useStyles();

  const [from, setFrom] = React.useState<Moment>(state.from || null);
  const [to, setTo] = React.useState<Moment>(state.to || null);

  React.useEffect(() => {
    if(validate) {
      if(!from && !to) {
        setState({});
      } else {
        setState({from, to})
      }
      setValid(true)
    }
  }, [validate])

  return <Grid
    container
    direction='column'
  >
    <Grid
      alignItems='center'
      container
      item
    >
      <Typography className={classes.text}>From</Typography>
      <DatePicker
        format='YYYY/MM/DD'
        inputVariant='outlined'
        onChange={(v) => {
          v.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          setFrom(v);
        }}
        size='small'
        value={from}
      />
    </Grid>
    <Grid
      alignItems='center'
      className={classes.bottomItem}
      container
      item
    >
      <Typography className={classes.text}>To</Typography>
      <DatePicker
        format='YYYY/MM/DD'
        inputVariant='outlined'
        onChange={(v) => {
          v.set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
          setTo(v);
        }}
        size='small'
        value={to}
      />
    </Grid>
  </Grid>;
};

export default DateFilter;